<template>
  <div class="page page-home">
    <div class="container">
      <!-- 头部区域 -->
      <header class="header">
        <h1 class="title">早鹰看电影</h1>
        <p class="subtitle">发现精彩电影，享受观影时光</p>
      </header>

      <!-- 搜索区域 -->
      <section class="search-section">
        <div class="search-box">
          <input type="text" placeholder="搜索电影..." class="search-input" v-model="searchText" />
          <button class="search-btn" @click="searchBtn">
            <span class="search-icon el-icon-search"></span>
          </button>
        </div>
      </section>
      <!-- 推荐电影 -->
      <section class="movie-section">
        <div class="movie-grid">
          <div
            class="movie-card"
            v-for="movie in movies"
            :key="movie.id"
            @click="goToMovieDetail(movie)"
          >
            <div class="movie-poster">
              <img :src="movie.poster" :alt="movie.title" />
            </div>
            <div class="movie-info">
              <h3 class="movie-title">{{ movie.title }}</h3>
              <p class="movie-genre">{{ movie.genre }}</p>
            </div>
          </div>
        </div>

        <!-- 加载状态指示器 -->
        <div class="loading-section" v-if="isLoading&&TotalCount>movies.length">
          <div class="loading-spinner"></div>
          <p class="loading-text">正在加载更多电影...</p>
        </div>

        <!-- 没有更多数据提示 -->
        <div class="no-more-section" v-if="TotalCount==movies.length">
          <p class="no-more-text">已加载全部电影</p>
        </div>
        <div class="empty-state" v-if="!isLoading && movies.length === 0">
          <div class="empty-icon el-icon-date"></div>
          <div class="empty-text">暂无电影</div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
import { getImageFromBinary, revokeImageURLs } from "@/utils/imageUtils";

export default {
  name: "HomeMain",
  data() {
    return {
      movies: [],
      searchText: "",
      // 分页相关数据
      currentPage: 1,
      pageSize: 12,
      isLoading: false,
      TotalCount: -1,
      TotalPages: 0
    };
  },
  methods: {
    async getInfo() {
      try {
        let data = {
          openid: this.$route.query.openid,
          clientsessionkey: this.$route.query.clientSessionKey
        };
        await api.GetInfo(data).then(res => {
          console.log(res);
          if (res.Code == 200 && res.Message == "OK" && res.Data) {
            localStorage.setItem("username", res.Data.NickName);
          } else if (res.Code == 400 && res.Message == "不存在此用户") {
            localStorage.removeItem("username");
            this.$message && this.$message.error("非法用户");
          }
        });
      } catch (error) {
        console.error("加载失败:", error);
        this.$message && this.$message.error("加载失败");
      }
    },
    searchBtn() {
      this.currentPage = 1;
      this.movies = [];
      this.getMovieList();
    },
    goToMovieDetail(movie) {
      this.$router.push({
        name: "movieDetail",
        query: { movieId: movie.id }
      });
    },

    // 加载更多电影数据
    loadMoreMovies() {
      if (
        this.TotalCount > this.movies.length &&
        this.currentPage < this.TotalPages
      ) {
        this.currentPage++;
        this.getMovieList();
      }
    },

    // 滚动事件处理
    handleScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // 当滚动到距离底部100px时触发加载更多
      if (scrollTop + windowHeight >= documentHeight - 100) {
        this.loadMoreMovies();
      }
    },

    // 初始化滚动监听
    initScrollListener() {
      window.addEventListener("scroll", this.handleScroll);
    },

    // 移除滚动监听
    removeScrollListener() {
      window.removeEventListener("scroll", this.handleScroll);
    },

    async getMovieList() {
      try {
        const formData = new FormData();
        formData.append("keyword", this.searchText);
        formData.append("pageindex", this.currentPage);
        formData.append("pagesize", this.pageSize);
        const response = await api.MovieListFormData(formData);
        if (response && response.data.length > 0) {
          this.TotalCount = response.TotalCount;
          this.TotalPages = response.TotalPages;
          // 使用 Promise.all 处理所有异步图片加载
          const moviePromises = [
            ...response.data.map(async item => {
              const posterUrl = await this.GetFile(item.FileAttachmentId);
              return {
                id: item.ID,
                title: item.MingCheng,
                genre: item.LeiXing,
                poster: posterUrl
              };
            })
          ];
          var addmovies = await Promise.all(moviePromises);
          this.movies = [...this.movies, ...addmovies];
        } else {
          this.movies = [];
        }
      } catch (error) {
        console.error("获取电影失败:", error);
        this.$message && this.$message.error("获取电影失败！");
        this.movies = [];
      }
    },
    async GetFile(id) {
      return await getImageFromBinary(id);
    }
  },

  async mounted() {
    this.initScrollListener();
    localStorage.setItem("openid", this.$route.query.openid);
    localStorage.setItem(
      "clientSessionKey",
      this.$route.query.clientSessionKey
    );
    if (this.isLoading == false) {
      this.isLoading = true;
    }
    try {
      await Promise.all([
        // 然后加载电影列表
        this.getInfo(),
        this.getMovieList()
      ]);
    } catch (error) {
      this.$message.error("接口请求出错");
    } finally {
      this.isLoading = false;
    }
  },

  beforeDestroy() {
    this.removeScrollListener();
    // 清理所有创建的图片URL，避免内存泄漏
    const imageUrls = this.movies
      .map(movie => movie.poster)
      .filter(url => url && url.startsWith("blob:"));
    revokeImageURLs(imageUrls);
  }
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  background: linear-gradient(
    135deg,
    rgba(195, 77, 52, 0.28) 0%,
    rgba(248, 248, 248, 0.08) 100%
  );
  padding: 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 16px;
}

/* 头部样式 */
.header {
  text-align: center;
  margin-bottom: 30px;
  color: rgb(80, 78, 78);
}

.title {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.subtitle {
  font-size: 16px;
  opacity: 0.9;
  margin: 0;
}

/* 搜索区域 */
.search-section {
  margin-bottom: 30px;
}

.search-box {
  display: flex;
  background: white;
  border-radius: 25px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  margin: 0 auto;
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  padding: 12px 20px;
  font-size: 16px;
  border-radius: 20px;
  background: transparent;
}

.search-btn {
  background: #667eea;
  border: none;
  border-radius: 25px;
  padding: 10px 30px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.search-btn:hover {
  background: #5a6fd8;
  transform: translateY(-1px);
}

.search-icon {
  padding: 0px 10px;
  font-size: 18px;
  color: white;
}

/* 分类区域 */
.category-section {
  margin-bottom: 40px;
}

.section-title {
  color: white;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.category-item {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 20px 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.category-item:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.category-icon {
  font-size: 24px;
  margin-bottom: 8px;
}

.category-name {
  color: white;
  font-size: 14px;
  font-weight: 500;
}

/* 电影区域 */
.movie-section {
}

.movie-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.movie-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  cursor: pointer;
}

.movie-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.movie-poster {
  position: relative;
  aspect-ratio: 2/3;
  overflow: hidden;
}

.movie-poster img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.movie-rating {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.movie-info {
  padding: 12px;
}

.movie-title {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 4px 0;
  color: #333;
  line-height: 1.3;
}

.movie-genre {
  font-size: 12px;
  color: #666;
  margin: 0;
}

/* 空状态样式 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #999;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.6;
}

.empty-text {
  font-size: 16px;
  color: #666;
}

/* 手机端响应式样式 */
@media (max-width: 767px) {
  .container {
    padding: 16px 12px;
  }

  .title {
    font-size: 24px;
  }

  .subtitle {
    font-size: 14px;
  }

  .search-box {
    max-width: 100%;
  }

  .search-input {
    font-size: 16px; /* 防止iOS缩放 */
    padding: 10px 16px;
  }

  .search-btn {
    padding: 10px 16px;
  }

  .category-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .category-item {
    padding: 16px 8px;
  }

  .category-icon {
    font-size: 20px;
  }

  .category-name {
    font-size: 13px;
  }

  .movie-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .movie-info {
    padding: 10px;
  }

  .movie-title {
    font-size: 13px;
  }

  .movie-genre {
    font-size: 11px;
  }

  .empty-state {
    padding: 40px 20px;
  }
}

/* 平板端响应式样式 */
@media (min-width: 768px) and (max-width: 1023px) {
  .container {
    padding: 24px 20px;
  }

  .title {
    font-size: 32px;
  }

  .subtitle {
    font-size: 18px;
  }

  .category-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  .category-item {
    padding: 24px 16px;
  }

  .category-icon {
    font-size: 28px;
  }

  .category-name {
    font-size: 16px;
  }

  .movie-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  .movie-info {
    padding: 16px;
  }

  .movie-title {
    font-size: 16px;
  }

  .movie-genre {
    font-size: 14px;
  }
}

/* 桌面端响应式样式 */
@media (min-width: 1024px) {
  .container {
    padding: 32px 24px;
  }

  .title {
    font-size: 36px;
  }

  .subtitle {
    font-size: 20px;
  }

  .search-box {
    max-width: 600px;
  }

  .search-input {
    font-size: 18px;
    padding: 16px 24px;
  }

  .search-btn {
    padding: 16px 24px;
  }

  .category-grid {
    grid-template-columns: repeat(6, 1fr);
    gap: 24px;
  }

  .category-item {
    padding: 28px 20px;
  }

  .category-icon {
    font-size: 32px;
  }

  .category-name {
    font-size: 18px;
  }

  .movie-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
  }

  .movie-info {
    padding: 20px;
  }

  .movie-title {
    font-size: 18px;
  }

  .movie-genre {
    font-size: 16px;
  }
}

/* 加载状态样式 */
.loading-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  margin-top: 20px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  color: #666;
  font-size: 14px;
  margin: 0;
  text-align: center;
}

.no-more-section {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  margin-top: 20px;
}

.no-more-text {
  color: #999;
  font-size: 14px;
  margin: 0;
  text-align: center;
  backdrop-filter: blur(10px);
}

/* 手机端加载状态样式 */
@media (max-width: 767px) {
  .loading-section {
    padding: 30px 16px;
  }

  .loading-spinner {
    width: 32px;
    height: 32px;
    border-width: 3px;
  }

  .loading-text {
    font-size: 13px;
  }

  .no-more-section {
    padding: 30px 16px;
  }

  .no-more-text {
    font-size: 13px;
    padding: 10px 20px;
  }
}
</style>


